module.exports = __webpack_public_path__ + "static/media/heart-empty.d1284430.svg";